import { sortBy } from 'lodash';
import { Map } from 'immutable';
import React, {useContext, useEffect} from 'react';
import * as actions from '../actions';
import componentServices from 'Scripts/componentServices';
import { FieldAppContext, IFieldAppState } from 'Scripts/contexts/fieldAppProvider';
import { ISiteVisit, SiteVisitType } from 'Scripts/models/siteVisitModel';
import { Expander } from './sharedComponents';
import { IJobCost } from 'Scripts/models/jobCostModel';
import { getCollection, ModelCollection } from 'Scripts/store';
import { getInstallSheets } from 'Scripts/schemaHelper';

function getInspectionVisitLabel(inspection: ISiteVisit, jobCosts: Map<string, IJobCost>) {
	return sortBy(inspection.jobCosts.map(jc => {
		const contract = jobCosts.get(jc.jobCostKey);
		const changeOrder = jc.changeOrderKey && contract.changeOrders[jc.changeOrderKey];
		const accountingId = changeOrder?.accountingId ?? contract.accountingId;
		const installSheet = getInstallSheets(contract)[jc.installSheetKey];
		const displayName = `${accountingId} ${installSheet.sortIndex + 1}) ${installSheet.name}`;

		return {
			accountingId,
			installSheetSort: installSheet.sortIndex,
			displayName
		};
	}), ['accountingId', 'installSheetSort']).map(i => i.displayName).join(', ')
}

function OpenInspectionsBucket() {
	const { router, routeParams, store } = componentServices;
	const { fieldActions, fieldState } = useContext(FieldAppContext);
	const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts });
	const siteVisits = getCollection({ store, collection: ModelCollection.siteVisits });
	const jobCostKey = routeParams.jobcostkey;
	const openInspections = siteVisits.filter(v => v.type === SiteVisitType.inspection && !v.completedDate && v.jobCosts.some(jc => jc.jobCostKey === jobCostKey));
	const rows = openInspections.toArray().map(inspection => <tr key={inspection.key}>
		<td></td>
		<td className='installSheets'>{getInspectionVisitLabel(inspection, jobCosts)}</td>
		<td className='right'><a className="button icon iconLabel inspect" onClick={() => componentServices.router.pushHistory(router.splicePathSegments(-1, 1, 'inspect', inspection.key))}><span>INSPECT</span></a></td>
		<td></td>
	</tr>);

	return openInspections.count()? <Expander title='Ready For Inspection'>
		<table className='interactive' cellPadding='0' cellSpacing='0'>
			<tbody> 
				{ rows }
			</tbody>
		</table>
	</Expander>: null;
}

export function FieldInspectionOverview() {
	return <div className='dashboard fieldApp'>
		<OpenInspectionsBucket />
	</div>;
	/*
	return <div className='dashboard fieldApp'>
		<section className='expander expanded'>
			<header><button tabIndex={1}><span className='icon inspect'>READY FOR INSPECTION <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<table className='interactive' cellPadding='0' cellSpacing='0'>
					<tbody> 
						<tr>
							<td></td>
							<td className='installSheets'>1. Pre-Install Demo</td>
							<td className='right'><a className="button icon iconLabel inspect"><span>INSPECT</span></a></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td className='installSheets'>2. Install, 3. Post Install Glass Inserts</td>
							<td className='right'><a className="button icon iconLabel inspect"><span>INSPECT</span></a></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon job'>JOB <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
                the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon specifications'>SPECIFICATIONS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
                the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon history'>HISTORY &amp; STATUS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
                the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon service'>SERVICE TASKS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
                the stuff here
			</div>
		</section>
		<section className='expander collapsed'>
			<header><button tabIndex={1}><span className='icon photos'>PHOTOS <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
                the stuff here
			</div>
		</section>
	</div>;
	*/
}